import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { NoteEvent } from './note_events';

@Injectable({ providedIn: 'root' })
export class NoteEventProvider extends DomainEventProvider<NoteEvent> {}
